import React, { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { searchConstants } from '../../../search-utils/searchConstants';
import { SortTypes } from '../../../search.types';
import styles from './sort_item.module.scss';
import { SearchFiltersRadio } from '../../search-filters-radio/SearchFiltersRadio';
import { SearchFiltersRadioIcon } from '../../search-filters-radio/SearchFiltersRadioIcon';

type Props = {
  handleClick: (type: SortTypes) => (event: MouseEvent<HTMLDivElement>) => void;
  isSelected: boolean;
  type: SortTypes;
};

export function SortItem({ isSelected, handleClick, type }: Props) {
  return (
    <SearchFiltersRadio onClick={handleClick(type)}>
      <SearchFiltersRadioIcon isSelected={isSelected} />

      <span className={styles.text}>
        <FormattedMessage id={searchConstants.sorts[type].labelId} />
      </span>
    </SearchFiltersRadio>
  );
}
